import { useEffect } from 'react'

const useKeyDown = (keycode, effect) => {
  useEffect(() => {
    document.onkeydown = (evt) => {
      evt = evt || window.event
      if (evt.keyCode === keycode) {
        effect()
      }
    }
    return () => {
      document.onkeydown = {}
    }
  })
}

export default useKeyDown
